var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupe1667(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 106,
    viewBox: "0 0 97 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1667",
    "data-name": "Groupe 1667",
    transform: "translate(-15464 -2528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1280",
    "data-name": "Rectangle 1280",
    d: "M0,0H97a0,0,0,0,1,0,0V57.5A48.5,48.5,0,0,1,48.5,106h0A48.5,48.5,0,0,1,0,57.5V0A0,0,0,0,1,0,0Z",
    transform: "translate(15464 2528)",
    fill: "#f3f8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_star",
    "data-name": "vuesax/linear/star",
    transform: "translate(15386 2375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "star",
    transform: "translate(108 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.082,2.208,20.8,7.635a3.35,3.35,0,0,0,2.189,1.619l4.918.817c3.145.524,3.885,2.806,1.619,5.057L25.7,18.951a3.347,3.347,0,0,0-.8,2.79l1.095,4.733c.863,3.746-1.125,5.2-4.44,3.237l-4.61-2.729a3.333,3.333,0,0,0-3.052,0l-4.61,2.729c-3.3,1.958-5.3.493-4.44-3.237l1.095-4.733a3.347,3.347,0,0,0-.8-2.79L1.309,15.128C-.942,12.877-.217,10.6,2.928,10.071l4.918-.817a3.358,3.358,0,0,0,2.174-1.619l2.713-5.427C14.213-.736,16.618-.736,18.082,2.208Z",
    transform: "translate(3.085 3.203)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H37V37H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe1667);
export default __webpack_public_path__ + "static/media/Groupe-1667.c9c35fb3dcc1d51ac53e1ce604ca0100.svg";
export { ForwardRef as ReactComponent };